import { combineReducers } from "redux";

import userSlice from './user/UserSlice';

const rootReducer = combineReducers({
    user:userSlice,
});

export default rootReducer;